if (!customElements.get('blog-posts-carousel')) {
  customElements.define(
    'blog-posts-carousel',
    class BlogPostsCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        if (!this.enableSlider && !this.enableSliderMobile) return;

        this.selectors = {
          itemsWrap: '.blog-posts-carousel__items-wrap',
          items: '.blog-posts-carousel__items',
          controls: '.swiper-controls',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.itemsWrap = this.querySelector(this.selectors.itemsWrap);
        this.items = this.querySelector(this.selectors.items);
        this.controls = this.querySelector(this.selectors.controls);
        this.pagination = this.querySelector(this.selectors.pagination);
        this.sliderInstance = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          if (this.enableSliderMobile) this.initSlider();
          else this.destroySlider();
        } else {
          if (this.enableSlider) this.initSlider();
          else this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const items = parseInt(this.dataset.items, 10) || 3;
        const columnGap = window.getComputedStyle(this.items).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat((columnGap || '0').replace('rem', '')) * 10 || 0;

        const additionModules = [FoxTheme.Swiper.Autoplay];

        this.sliderOptions = {
          slidesPerView: 'auto',
          spaceBetween,
          breakpoints: {
            768: {
              slidesPerView: items,
            },
          },
          navigation: this.controls
            ? {
                nextEl: this.controls.querySelector('.swiper-button-next'),
                prevEl: this.controls.querySelector('.swiper-button-prev'),
              }
            : undefined,
          pagination: this.pagination
            ? {
                el: this.pagination,
                clickable: true,
              }
            : undefined,
          loop: false,
          watchOverflow: true,
          threshold: 2,
        };

        const autoplayDelay = parseInt(this.dataset.autoplay, 10);
        if (autoplayDelay > 0) {
          this.sliderOptions = {
            ...this.sliderOptions,
            autoplay: {
              delay: autoplayDelay,
              disableOnInteraction: false,
            },
          };
        }

        this.itemsWrap.classList.add(this.classes.swiper);
        this.items.classList.remove(this.classes.grid);
        this.items.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this.itemsWrap, this.sliderOptions, additionModules);
        this.sliderInstance.init();

        this.handleAccessibility();
      }

      handleAccessibility() {
        if (!this.sliderInstance) return;
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              const slide = element.closest('.swiper-slide');
              if (slide) {
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        if (this.itemsWrap) this.itemsWrap.classList.remove(this.classes.swiper);
        if (this.items) {
          this.items.classList.remove(this.classes.swiperWrapper);
          this.items.classList.add(this.classes.grid);
        }
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

